interface SectionTransitionProps {
  children: React.ReactNode;
  className?: string;
  isActive: boolean;
  scrollable?: boolean;
}

const SectionTransition = ({ children, className = "", isActive, scrollable = false }: SectionTransitionProps) => {
  return (
    <div className={`fullpage-section ${scrollable ? 'fullpage-section-scrollable' : ''} ${className}`}>
      <div
        className={`transition-all duration-1000 ease-out ${
          isActive
            ? "opacity-100 scale-100"
            : "opacity-0 scale-95"
        }`}
      >
        <div className="stagger-container">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SectionTransition;
